import { SubscriptionResource } from 'dy-frontend-http-repository/lib/modules/Subscription/resources';
import domain from './domain';
import { resetSubscription } from './events';

// Subscription
export const $subscription = domain.createStore<SubscriptionResource | null>(null).reset(resetSubscription);
